import { useState, cloneElement, Children } from 'react';
import { styled } from '@classify/react-core-components/styles';
import cx from 'classnames';
import Menu from '@mui/material/Menu';
import MoreIconButton from './MoreIconButton';
import MenuItem from './MenuItem';
import Divider from './Divider';
const PREFIX = 'ActionsMenu';
const classes = {
  menuPaper: `${PREFIX}-menuPaper`,
  dividerRoot: `${PREFIX}-dividerRoot`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(/* istanbul ignore next */({
  theme: {
    spacing
  }
}) => ({
  [`& .${classes.menuPaper}`]: {
    marginTop: spacing(1)
  },
  [`& .${classes.dividerRoot}`]: {
    margin: spacing(1, 0)
  }
}));
export default function ActionsMenu({
  className = '',
  button = <MoreIconButton ariaLabel="" />,
  align = 'left',
  verticalAlign = {
    anchor: 'bottom',
    transform: 'top'
  },
  children,
  translations = {
    ariaLabelMore: 'more'
  },
  onOpen = () => {},
  onClose = () => {},
  dataTestId = '',
  buttonProps = {}
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleButtonClick = event => {
    setAnchorEl(event.currentTarget);
    onOpen(event);
  };
  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };
  const actionsElements = Children.map(children, child => {
    if (!child) {
      return child;
    }
    return cloneElement(child, {
      onClick() {
        const {
          onClick,
          data
        } = child.props;
        if (typeof onClick === 'function') {
          onClick(data);
        }
        handleClose();
      }
    });
  });
  const buttonComponent = cloneElement(button, {
    'aria-label': translations.ariaLabelMore,
    'aria-haspopup': true,
    onClick: handleButtonClick,
    'data-testid': dataTestId,
    ...buttonProps
  });
  return <Root>
      {buttonComponent}
      <Menu MenuListProps={{
      component: 'nav'
    }} classes={{
      paper: cx(classes.menuPaper, className)
    }} anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{
      vertical: verticalAlign.anchor,
      horizontal: align
    }} transformOrigin={{
      vertical: verticalAlign.transform,
      horizontal: align
    }}>
        {actionsElements}
      </Menu>
    </Root>;
}
ActionsMenu.Item = MenuItem;
ActionsMenu.Divider = Divider;